export type ToggleStateMap = Record<string, boolean>;
export type GlobalToggleMode = 'expand-all' | 'collapse-all' | null;

const displayToggleStateByProject = new Map<string, ToggleStateMap>();
let globalToggleMode: GlobalToggleMode = null;

const normalizeString = (value: unknown): string => {
  if (value === null || value === undefined) return '';

  if (typeof value === 'string') {
    return value.trim();
  }

  if (typeof value === 'number' || typeof value === 'bigint' || typeof value === 'boolean') {
    return `${value}`.trim();
  }

  return '';
};

const toKeyPart = (value: unknown): string | null => {
  if (value === null || value === undefined) return null;
  const normalized = normalizeString(value);
  if (!normalized) return null;
  return normalized;
};

export const getProjectToggleState = (projectKey: string): ToggleStateMap | undefined => {
  return displayToggleStateByProject.get(projectKey);
};

export const setProjectToggleState = (projectKey: string, state: ToggleStateMap): void => {
  displayToggleStateByProject.set(projectKey, { ...state });
};

/** Clears the saved expansion state for a project so its default view can be restored. */
export const resetProjectToggleState = (projectKey: string): void => {
  displayToggleStateByProject.delete(projectKey);
};

export const setGlobalToggleMode = (mode: GlobalToggleMode): void => {
  globalToggleMode = mode;
};

export const getGlobalToggleMode = (): GlobalToggleMode => {
  return globalToggleMode;
};

export const getProjectDisplayToggleKey = (project?: any, selectedProject?: any): string => {
  const selectedId =
    toKeyPart(selectedProject?.perfId) ??
    toKeyPart(selectedProject?.projectId) ??
    toKeyPart(selectedProject?.id) ??
    toKeyPart(selectedProject?.pipId) ??
    toKeyPart(selectedProject?.pipID);

  if (selectedId) {
    return `selected-id:${selectedId}`;
  }

  const selectedName =
    toKeyPart(selectedProject?.nameOfProject) ??
    toKeyPart(selectedProject?.pipDesc);

  if (selectedName) {
    return `selected-name:${selectedName.toLowerCase()}`;
  }

  const projectId =
    toKeyPart(project?.perfId) ??
    toKeyPart(project?.projectId) ??
    toKeyPart(project?.id) ??
    toKeyPart(project?.pipId) ??
    toKeyPart(project?.pipID);

  if (projectId) {
    return `project-id:${projectId}`;
  }

  const projectName =
    toKeyPart(project?.nameOfProject) ??
    toKeyPart(project?.pipDesc);

  if (projectName) {
    return `project-name:${projectName.toLowerCase()}`;
  }

  return 'default';
};
